export default __webpack_public_path__ + "static/media/GlossaryIcon.b4bbd0d5.svg";